import { useChannelSettingsContext } from "@wearesweet/sendbird-uikit-react/ChannelSettings/context";
import Label, { LabelColors, LabelTypography } from "@wearesweet/sendbird-uikit-react/ui/Label";
import { Toggle } from "@wearesweet/sendbird-uikit-react/ui/Toggle";
import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { PINNED } from "../../../utils/channelStatus";
import { PinnedIcon } from "./PinnedIcon";

export const ChannelPinned = (props: any) => {
  const [pinned, setPinned] = useState<boolean>(false);
  const { channel } = useChannelSettingsContext();

  useEffect(() => {
    setPinned((channel && channel.customType.includes(PINNED)) || false);
  }, [channel]);

  return (
    <div className="sendbird-channel-settings__freeze">
      <PinnedIcon className={"sendbird-channel-settings__accordion-icon"} />
      <Label type={LabelTypography.SUBTITLE_1} color={LabelColors.ONBACKGROUND_1}>
        {t("pinnedChannel")}
      </Label>
      <Toggle
        className="sendbird-channel-settings__frozen-icon"
        checked={pinned}
        onChange={() => {
          if (channel) {
            let newCustomType = channel.customType.replace("p", "");

            // they are toggling pinned on, so add p to the custom type
            if (!pinned) {
              newCustomType += "p";
            }

            channel
              .updateChannel({
                customType: newCustomType,
              })
              .then(() => {
                setPinned(!pinned);
              });
          }
        }}
      />
    </div>
  );
};
